// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"181":"dd6bc33c","239":"d9d04dfb","977":"2df840fb"}[chunkId] + ".chunk.js";
};